import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { AssignPersons } from "../components/AssignPersons";
import { PageHeader } from "../components/PageHeader";
import { TableSkeleton } from "../components/TableSkeleton";
import { Person } from "../model/person";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { clearDoctorAvaliableCaretakers, fetchDoctorAvaliableCaretakers } from "../features/caretakersToAssign/caretakersToAssignSlice";
import { assingCaretakersToDoctor, cancelAddPersonsToDoctor } from "../features/doctor/doctorSlice";
import { useTranslate } from "../i18n";
import { getErrorMessage } from "../utils/getErrorMessage";


export const AssignCaretakersToDoctor = (
  props: {
    doctorId: string;
  }
) => {

  const dispatch = useAppDispatch();
  const t = useTranslate();
  const caretakers = useAppSelector((state) => state.caretakersToAssign.caretakersAvaliable);
  const status = useAppSelector((state) => state.caretakersToAssign.status);
  const error = useAppSelector((state) => state.caretakersToAssign.error);
  const navigate = useNavigate();

  const [isErrorDismissed, setIsErrorDismissed] = useState(false);

  useEffect(() => {
    if (status == "idle") {
      dispatch(fetchDoctorAvaliableCaretakers(props.doctorId));
    }
  });

  const handleErrorOk = () => {
    setIsErrorDismissed(true);
    dispatch(clearDoctorAvaliableCaretakers());
  }

  const handleAuthOk = () => {
    setIsErrorDismissed(true);
    navigate("/")
  }

  const onCancel = () => {
    dispatch(cancelAddPersonsToDoctor());
  }

  const oncaretakersAssign = (persons: Person[]) => {
    dispatch(assingCaretakersToDoctor({ doctorId: props.doctorId, caretakerIds: persons.map((person) => person.id) }));
  }

  if (status === "idle" || status === "loading") {
    return <>
      <PageHeader eyebrow={t("assign.eyebrow")} title={t("assign.caretakers.title")} />
      <TableSkeleton />
    </>;
  }

  if (status === "auth-error") {
    return <Modal
      title={t("auth.failed.title")}
      visible={!isErrorDismissed}
      onOk={handleAuthOk}
      okText={t("common.signIn")}
      cancelButtonProps={{ hidden: true }}
    >
      <p>{t("auth.failed.body")}</p>
    </Modal>
  }

  if (status === "error") {
    const errorMessage = getErrorMessage(error, t);
    return <Modal
      title={errorMessage.title}
      visible={!isErrorDismissed}
      onOk={handleErrorOk}
      cancelButtonProps={{ hidden: true }}
    >
      <p>{errorMessage.details}</p>
    </Modal>
  }

  return <AssignPersons
    title={t("assign.caretakers.title")}
    subtitle={t("assign.caretakers.forDoctor")}

    onPersonsAssign={oncaretakersAssign}
    onCancel={onCancel}

    persons={caretakers.map(p => {
      return {
        id: p.id,
        firstName: p.firstName,
        lastName: p.lastName,
        phoneNumber: p.userAccount?.mobileNumber,
        email: p.userAccount?.emailAddress
      } as Person;
    })} />;
}
